import React from "react"
import { defaultLink, currentLink } from "./PageNumber.css"

type Props = {
  link: string
  num: number
  current?: boolean
  currentNum?: number
}

export const PageNumber: React.FC<Props> = ({
  link,
  num,
  current,
  currentNum,
}) => {
  let relLink = ""
  if (currentNum && currentNum - 1 === num) {
    relLink = "prev"
  }
  if (currentNum && currentNum + 1 === num) {
    relLink = "next"
  }

  const linkClass = current ? `${defaultLink} ${currentLink}` : defaultLink
  return (
    <a
      href={link}
      title={`Page ${num}`}
      rel={relLink ? `${relLink} noreferrer` : "noreferrer"}
    >
      <span className={linkClass}>{num}</span>
    </a>
  )
}
